var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttachment = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.195 2.673a3.167 3.167 0 0 0-4.47 0L2.542 8.857a3.167 3.167 0 0 0 0 4.47c.616.616 1.43.923 2.243.923.815 0 1.61-.308 2.241-.92l4.186-4.186a1.974 1.974 0 0 0-.048-2.701l-.002-.003a1.94 1.94 0 0 0-2.753 0L4.942 9.89a.743.743 0 0 0 0 1.037.743.743 0 0 0 1.037 0l3.433-3.433a.484.484 0 0 1 .68 0 .484.484 0 0 1 0 .68L5.975 12.29c-.65.651-1.727.654-2.397 0a1.71 1.71 0 0 1 .002-2.397L9.762 3.71c.651-.651 1.728-.654 2.399.002.661.647.654 1.72 0 2.392a.714.714 0 0 0 .005 1.047l.002.002a.743.743 0 0 0 1.027-.01 3.167 3.167 0 0 0 0-4.47",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttachment);
export default ForwardRef;